import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { COD_CASE_PORTAF } from 'src/app/shared/constants/data.const';

@Component({
  selector: 'theme-grafico-fondos',
  templateUrl: './grafico-fondos.component.html',
  styleUrls: ['./grafico-fondos.component.scss']
})
export class GraficoFondosComponent implements OnInit, OnChanges {
  @Input() colores: string[] = [];
  @Input() isSoles: boolean = false;
  @Input() montos: number[] = [];
  @Input() montosTexto: string[] = [];
  @Input() labelsIn: string[] = [];
  @Input() porcentajes: number[] = [];
  @Input() statePortfolio: string;

  chartDatasets: ChartDataSets[] = [];
  chartOptions: ChartOptions = {};

  constructor() { }

  ngOnInit(): void {
    this.armarGrafico();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.initOptions();
    this.armarGrafico();
  }

  initOptions() {
    this.chartOptions = {
      responsive: true,
      aspectRatio: 1,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: true,
        displayColors: false,
        backgroundColor: "rgba(235, 236, 237, 0.85)",
        titleFontStyle: "400",
        titleFontColor: "#272727",
        bodyFontColor: "#272727",
        titleFontSize: 10,
        bodyFontSize: 10,
        callbacks: {
          title: (item, data) => `${data.labels[item[0].index]}`,
          label: (tooltipItem, data) => `%:${this.porcentajes[tooltipItem.index]}%`,
          afterLabel: (tooltipItem, data) => `Monto: ${this.montosTexto[tooltipItem.index]}`,
        },
      },
    };
  }

  armarGrafico() {
    this.chartDatasets = [
      {
        data: this.statePortfolio == COD_CASE_PORTAF.CASE4 ? [100] : this.montos,
        backgroundColor: this.statePortfolio == COD_CASE_PORTAF.CASE4 ? ['#B9BBBE'] : this.colores,
        borderWidth: 0,
        datalabels: { display: false },
        hoverBorderWidth: 4,
        hoverBorderColor: "rgba(219, 209, 187, 0.5)",
      }
    ]
  }

}
